import { DAIMI_AP_INTRO, DAIMI_AP_SLUG } from '@/content/daimiAirports'
import { focus } from '@/content/reportBuilder'
import type { Report } from '@/content/reportBuilder'

export const report: Report = {
  // The fourth report with a designed page of its own — asked for on
  // 2026-08-27 with a full-page screenshot of the live Airports Industry Focus
  // page as the reference. See `content/daimiAirports.ts` and
  // `pages/DaimiAirports.tsx`. The index card still reads this entry's cover
  // and title.
  ...focus(
    DAIMI_AP_SLUG,
    'Airports',
    'daimi-report-2026-airports-cover',
    '8585de1c-19d6-4e33-85d0-10a4b208e6c6-digitopia-daimi-2026-report-airports.pdf',
  ),
  // The page's own opening paragraphs, so the search result and the page agree
  // — `prerender.tsx` takes the meta description from `body[0]`. They used to
  // be the series description, which is what `stillToCome({ copy: true })`
  // said out loud.
  body: DAIMI_AP_INTRO.body,
  layout: 'airports-focus',
  // Nothing left for `stillToCome` to say: file, cover and its own words. What
  // is still open about it is section-by-section on its page, and
  // `daimiAirportsChecks()` carries that into the manifest.
  check: undefined,
}

/** Its place in the index grid — the order the imported page listed them. */
export const order = 3
